export default __webpack_public_path__ + "static/media/vale-refeicao-vr.1bb00955.png";